// Helper function to convert bytes to MB
export const bytesToMB = (bytes) => `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
